import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;
`;

export const ButtonWrap = styled.button`
  width: 100%;
  max-width: 640px;
  border: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 8.43%, #FFFFFF 17.79%);
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
`;
